import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import Locale from "@/helper/locale/locale.js";
//core
import { CallbackEvent } from "@/core/Utility/CallbackEvent.js";
//service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';

/**
 * setup
 * @method initial
 * @method reinitial
 * setter
 * @method updateCampaignInfo
 * @method selectSubCampaign
 * @method setSelectedQuantity
 * event
 * @method onApiError
 * @method onApiSuccess
 */
export function DetailController () {
    this.lbl = Locale.getLbl();

    this.isLoading = false;
    this.campaignConfig = null;
    this.campaign = {};
    this.campaignId = null;
    this.type = '';
    this.point = 0;
    this.pointType = '';
    this.price = 0;
    this.originalPrice = 0;
    this.discount = 0;
    this.qty = 0;
    this.quantity = 0;
    this.isFavorite = false;
    //selected for redeem
    this.selectedCampaignId = null;
    this.selectedQuantity = 1;
    //modal
    this.modalController = null;
    //event
    this.cbApiError = new CallbackEvent();
    this.cbApiSuccess = new CallbackEvent();
    this.campaignType = Vue.CampaignType;

    //#region setup
    /**
     * @param {CampaignConfigModel} campaignConfig /core/Campaign/model/CampaignConfigModel.js
     * @param {ModalController} controller /components/Modal/ModalController.js
     */
    this.initial = (campaignConfig, controller) => {
        this.campaignConfig = campaignConfig;
        this.modalController = controller;
        this.getCampaignDetail();
    };
    this.reinitial = (isSkipLoading) => {
        this.lbl = Locale.getLbl();
        this.getCampaignDetail(isSkipLoading);
    };
    //#endregion setup

    //#region setter
    this.updateCampaignInfo = () => {
        this.campaignId = this.campaign.id;
        this.selectedCampaignId = this.campaign.id;
        this.type = this.campaign.type;

        if(this.campaign.type == Vue.CampaignType.Privilege){
            this.point = this.campaign.maximumPartialPoints;
        }else{
            this.point = this.campaign.pointPerUnit;
        }

        this.pointType = this.campaign.pointType;
        this.price = this.campaign.pricePerUnit;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.qty = this.campaign.qty;
        this.quantity = this.campaign.quantity;
        this.isFavourite = this.campaign.isFavourite;
    };
    this.selectSubCampaign = selectedItem => {
        this.selectedCampaignId = selectedItem.id;
        this.type = selectedItem.type;
        this.point = selectedItem.pointPerUnit;
        this.price = this.campaign.pricePerUnit;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.quantity = selectedItem.quantity;
    };
    this.setSelectedQuantity = quantity => {
        this.selectedQuantity = quantity;
    };
    //#endregion setter

    //#region campaign
    this.getCampaignDetail = isSkipLoading => {
        if (!isSkipLoading) this.showLoading();

        var token = Account.getToken();
        BzbsCampaign.apiGetCampaignDetail(token, this.campaignConfig).subscribe((campaign) => {
            this.campaign = campaign;
            this.updateCampaignInfo();

            this.hideLoading();
            this.eventApiSuccess({tag: 'get-campaign'});
        }, (err) => {
            this.hideLoading();
            this.eventApiError({tag: 'get-campaign', "err": err})
        });
    };
    //#endregion campaign

    //#region favourite
    //#endregion favourite

    //#region loading
    this.showLoading = function () {
        if (this.isLoading) return true;
        this.isLoading = true;

        this.modalController.loadingModal.show();
    };
    this.hideLoading = function () {
        this.isLoading = false;
        this.modalController.loadingModal.hide();
    };
    //#endregion

    //#region event
    // error api
    this.onApiError = function(callback) {
        this.cbApiError.onCallback(callback);
    };
    this.eventApiError = function(info) {
        this.cbApiError.sendCallback(info);
    };

    // api success
    this.onApiSuccess = function(callback) {
        this.cbApiSuccess.onCallback(callback);
    };
    this.eventApiSuccess = function(info) {
        this.cbApiSuccess.sendCallback(info);
    };
    //#endregion event
}
